import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useNotification } from '../Components/GlobalNotification';

export const ProtectedRoutes = (props) => {
    const { showNotification } = useNotification();
    const { Components } = props;
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAuthentication = () => {
            const loginToken = localStorage.getItem('login');
            const userInfo = localStorage.getItem('userInfo');

            if (!loginToken) {
                showNotification({ type: 'error', title: 'Error', message: 'Please login to access this page' });
                navigate('/login');
                return;
            }

            if (!userInfo) {
                showNotification({ type: 'error', title: 'Error', message: 'User information not found' });
                navigate('/login');
                return;
            }

            try {
                // Validate user info structure
                const user = JSON.parse(userInfo);
                if (!user.role) {
                    showNotification({ type: 'error', title: 'Error', message: 'Invalid user role' });
                    navigate('/login');
                    return;
                }

                setIsAuthenticated(true);
            } catch (error) {
                console.error('Error parsing user info:', error);
                showNotification({ type: 'error', title: 'Error', message: 'Invalid user data' });
                navigate('/login');
                return;
            }

            setIsLoading(false);
        };

        checkAuthentication();
    }, [navigate]); // Added dependency array

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return null; // Will redirect in useEffect
    }

    return (
        <>
            <Components />
        </>
    )
}
